import { render, staticRenderFns } from "./transferencia-history.vue?vue&type=template&id=181e67e4"
import script from "./transferencia-history.vue?vue&type=script&lang=ts"
export * from "./transferencia-history.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports